import { IFilterViewModel } from '../../FiltersViewModel'
import { isNil } from 'lodash'
import { action, computed, makeObservable, observable } from 'mobx'

/**
 * A filter for a boolean flag.
 */
export class FlagFilter<TKey> implements IFilterViewModel<TKey, boolean> {
  /**
   * @inheritdoc
   */
  key: TKey

  /**
   * @inheritdoc
   */
  title: string

  /**
   * @inheritdoc
   */
  @observable
  value = false

  /**
   * @inheritdoc
   */
  readonly editing = false

  constructor(key: TKey, title: string, initialValue = false) {
    this.key = key
    this.title = title
    this.value = initialValue

    makeObservable(this)
  }

  /**
   * @inheritdoc
   */
  @computed
  get valid() {
    return !isNil(this.value)
  }

  /**
   * @inheritdoc
   */
  toString() {
    return this.title
  }

  /**
   * @inheritdoc
   */
  @action.bound
  clearValue(): void {
    this.value = false
  }

  /**
   * Sets the flag filter's value.
   */
  @action.bound
  setValue(value: boolean): void {
    this.value = value
  }

  /**
   * @inheritdoc
   */
  startEditing(): void {}

  /**
   * @inheritdoc
   */
  stopEditing(): void {}

  /**
   * @inheritdoc
   */
  serialize() {
    return JSON.stringify(this.value)
  }

  /**
   * @inheritdoc
   */
  @action.bound
  deserialize(serialized: unknown) {
    if (typeof serialized === 'string') {
      try {
        this.setValue(JSON.parse(serialized))
      } catch (e) {
        this.clearValue()
      }
    }
  }
}
